import ReactApexChart from "react-apexcharts";

const StockBreakdownChart = ({ stockItems }) => {
  const categoryQuantities = stockItems.reduce((acc, item) => {
    const category = item.medicineCategory || "Uncategorized";
    const quantity = item.availableQuantity || 0;
    acc[category] = (acc[category] || 0) + quantity;
    return acc;
  }, {});

  const labels = Object.keys(categoryQuantities);
  const series = Object.values(categoryQuantities);

  // Calculate the grand total of all stock items
  const totalStock = series.reduce((sum, current) => sum + current, 0);
  
  const chartColors = ['#465DFF', '#6AC75A', '#67BAF1', '#F59E0B', '#EF4444', '#D946EF', '#10B981', '#F97316'];

  const chartState = {
    series: series,
    options: {
      chart: {
        type: 'donut',
      },
      labels: labels,
      colors: chartColors,
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          donut: {
            size: "75%",
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: '16px',
                fontWeight: 'bold',
                formatter: function (val) {
                  if (val.length > 15) {
                    return val.slice(0, 14) + '...';
                  }
                  return val;
                },
              },
              total: {
                show: true,
                label: 'Total Stock',
                fontSize: '18px',
                fontWeight: 600,
                color: '#373d3f',
                formatter: () => totalStock.toLocaleString(),
              },
            },
          },
        },
      },
    },
  };

  const breakdownData = labels.map((label, index) => ({
    name: label,
    quantity: series[index],
    percentage: totalStock > 0 ? ((series[index] / totalStock) * 100).toFixed(2) : "0.00",
    color: chartColors[index % chartColors.length],
  }));

  return (
    <div>
      {/* Chart Component */}
      <div id="chart" className="dashboard-donut-chart -mt-4">
        <ReactApexChart
          options={chartState.options}
          series={chartState.series}
          type="donut"
          height={250}
        />
      </div>

      {/* Detailed Breakdown List */}
      <div className="mt-4 space-y-3 px-2">
        {breakdownData.map((item, index) => (
          <div key={index} className="flex items-center justify-between text-sm">
            <div className="flex items-center gap-3">
              <span 
                className="h-3 w-3 rounded-full" 
                style={{ backgroundColor: item.color }}
              ></span>
              <span>{item.name}: {item.quantity.toLocaleString()}</span>
            </div>
            <span className="font-medium text-gray-600">{item.percentage}%</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StockBreakdownChart;